export default {
    // 性别
    gender(value) {
        const gender = Number(value);
        let str = '其他';
        switch (gender) {
            case 1:
                str = '男';
                break;
            case 2:
                str = '女';
                break;
        }
        return str;
    },
    // 考生类型
    userType(value) {
        const userType = Number(value);
        let str = '';
        switch (userType) {
            case 1:
                str = '文科';
                break;
            case 2:
                str = '理科';
                break;
            default:
                str = '不分文理';
                break;
        }
        return str;
    },
    // 显示前12个字符
    shortName(value) {
        return value ? value.substr(0, 12) : '';
    }
};
